import { Injectable } from '@angular/core';
import { ApiRequestService } from '../shared/api-request.service';
import { IncidentCauseModel } from './incident-cause.model';
import { Observable } from 'rxjs';
import { ApiResponseModel } from '../models/api-response.model';
import { ActionModel } from '../actions/action.model';

@Injectable({
  providedIn: 'root'
})
export class IncidentCauseService {
  private readonly resourceUrl = 'incident-causes';

  constructor(private api: ApiRequestService) {}

  create(
    cause: IncidentCauseModel
  ): Observable<ApiResponseModel<IncidentCauseModel>> {
    return this.api.makeRequestObservable('post', 'v1/' + this.resourceUrl, cause);
  }

  update(
    cause: IncidentCauseModel
  ): Observable<ApiResponseModel<IncidentCauseModel>> {
    return this.api.makeRequestObservable(
      'put',
      'v1/' + this.resourceUrl + `/${cause.id}`,
      cause
    );
  }

  remove(ids: number[]): Observable<ApiResponseModel<void>> {
    return this.api.makeRequestObservable(
      'delete',
      'v1/' + this.resourceUrl + `/${ids.join(',')}`
    );
  }

  getActions(id: number): Observable<ApiResponseModel<ActionModel[]>> {
    return this.api.makeRequestObservable(
      'get',
      'v1/' + this.resourceUrl + `/${id}/actions`
    );
  }
}
